var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diagram-container"},[(_vm.currentTask)?_c('DiagramBuilder',{ref:"diagramBuilder",attrs:{"taskProp":_vm.currentTask,"show-toolbar":_vm.showToolbar,"show-list":_vm.showList,"tool":_vm.tool},on:{"zoomChange":_vm.onZoomChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }